import {
  Dropdown,
  IconButton,
  Menu,
  MenuButton as JoyMenuButton,
  MenuButtonProps,
  MenuItem,
  Stack,
  Typography,
} from '@mui/joy';

import { IOption } from 'core/types';
import { Color, Level, Size, Variant } from 'theme/enums';

interface IProps extends MenuButtonProps {
  label?: string | JSX.Element;
  icon?: JSX.Element;
  menuItems?: IOption[];
  menuSize?: Size;
}

const MenuButton = ({ label, menuItems = [], icon, menuSize, ...rest }: IProps) => {
  const defaultSlotProps = {
    root: {
      size: rest.size || Size.SM,
      variant: rest.variant || Variant.SOLID,
      color: rest.color || Color.PRIMARY,
    },
  };

  return (
    <Dropdown>
      <JoyMenuButton
        slots={icon ? { root: IconButton } : {}}
        slotProps={icon ? defaultSlotProps : {}}
        {...rest}
      >
        {label}

        {icon && icon}
      </JoyMenuButton>

      <Menu
        placement="bottom-end"
        size={menuSize || rest?.size}
        style={{ zIndex: 'var(--joy-zIndex-modal)' }}
      >
        {menuItems?.map((option: IOption) => {
          if (option?.hide) {
            return null;
          }

          if (option?.component) {
            return option.component;
          }

          return (
            <MenuItem
              // Two options may share a label and differ by their description.
              key={[option?.label, option?.description].filter(Boolean).join(':')}
              color={option?.color}
              onClick={option?.onClick}
              disabled={option?.disabled}
              selected={option?.selected}
            >
              {option?.description ? (
                <Stack>
                  {option.label}
                  <Typography level={Level.BODY_XS} sx={{ color: 'text.tertiary' }}>
                    {option.description}
                  </Typography>
                </Stack>
              ) : (
                option?.label
              )}
              <Typography level={Level.BODY_SM} color={Color.NEUTRAL}>
                {option?.labelExtra}
              </Typography>
            </MenuItem>
          );
        })}
      </Menu>
    </Dropdown>
  );
};

export default MenuButton;
